import { isEditableMetadataPath } from "./isEditableMetadataPath";

/**
 * Removes derived metadata for no-op comparison, retaining complete variant catalogue contents.
 *
 * @param value - Domain data, nested property or array being compared for unified history.
 * @param path - Decoded property segments locating the current value within editable data.
 * @param excludedFields - Comparison-specific metadata names, or the default unified history exclusions.
 * @returns Comparable data with metadata omitted only outside patch catalogues.
 */
export const omitStaticMetadata = (
  value: unknown,
  path: string[] = [],
  excludedFields?: ReadonlySet<string>,
): unknown => {
  if (path.includes("allVariantPatches")) return value;
  if (Array.isArray(value)) {
    return value.map((item: unknown, index: number) =>
      omitStaticMetadata(item, [...path, String(index)], excludedFields),
    );
  }
  if (value !== null && typeof value === "object") {
    const entries: [string, unknown][] = Object.entries(value);
    return Object.fromEntries(
      entries
        .filter(
          ([key, item]) =>
            item !== undefined && !isEditableMetadataPath([...path, key], excludedFields),
        )
        .map(([key, item]) => [key, omitStaticMetadata(item, [...path, key], excludedFields)]),
    );
  }
  return value;
};
